import React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { serialize } from "next-mdx-remote/serialize";

import getTranslationByPath from "../services/getTranslationByPath.mjs";
import Hero from "../components/About/Hero";
import Gallery from "../components/About/Gallery";
import Numbers from "../components/About/Numbers";
import OurBeliefs from "../components/About/OurBeliefs";
import OurTeam from "../components/About/OurTeam";
import Container from "../components/Common/Container";
import RequestADemo from "../components/Common/RequestADemo";
import OurStory from "../components/About/OurStory";

import MetaTags from "../components/Common/MetaTags/MetaTags.js";

export default function About({ heroSubtitle, ourStoryContent }) {
  const theme = useTheme();
  const { t } = useTranslation(["about", "common"]);

  return (
    <>
      <MetaTags scope="about" />
      <Box bgcolor={theme.palette.alternate.main} position={"relative"}>
        <Container position="relative" zIndex={2}>
          <Hero
            pageTitle={t("navbar.about_us", { ns: "common" })}
            title1={t("hero.title_1")}
            title2={t("hero.title_2")}
            title3={t("hero.title_3")}
            subtitle={heroSubtitle}
          />
        </Container>
        <Box
          component={"svg"}
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 1921 273"
          sx={{
            position: "absolute",
            width: "100%",
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: 1,
            height: "35%",
          }}
        >
          <polygon
            fill={theme.palette.background.paper}
            points="0,273 1921,273 1921,0 "
          />
        </Box>
      </Box>

      <Container>
        <Gallery />
      </Container>

      <Container
        maxWidth={"800px !important"}
        paddingTop={"0 !important"}
        paddingBottom={"0 !important"}
      >
        <Numbers numbers={t("numbers", { returnObjects: true })} />
        <Container marginTop={3}>
          <Divider />
        </Container>
      </Container>

      <Container paddingTop={"0 !important"}>
        <OurBeliefs />
      </Container>

      <Box
        bgcolor={theme.palette.alternate.dark}
        marginBottom={4}
        paddingTop={3}
        paddingBottom={5}
      >
        <Container>
          <OurTeam />
        </Container>
      </Box>

      <Container>
        <OurStory content={ourStoryContent} />
      </Container>

      <RequestADemo title={t("request_a_demo.title")} />
    </>
  );
}

export async function getStaticProps({ locale }) {
  const { content } = getTranslationByPath("about", locale);

  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "about"])),
      heroSubtitle: await serialize(content.hero.subtitle),
      ourStoryContent: await serialize(content.our_story.content),
    },
  };
}
